module.exports = __webpack_public_path__ + "img/kia-jt-bg.fe89f280.jpg";